export default {
  state: {
    icons: [],
    banners: []
  },

  mutations: {
    updateIcons(state, payload) {
      state.icons = payload;
    },
    updateBanners(state, payload) {
      state.banners = payload;
    }
  }
};
